export const getAppliedHandicap = (value: string) =>
  ['-1', '-2', '-3'].includes(value) ? `lines${value}` : '';
